export default "__VITE_ASSET__B7E4hsh7__"